import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../app/axiosInterceptor';
import {
  toRejectPayload,
  setHistoryError,
  clearHistoryError,
  clearAllHistoryErrors
} from './historyError';

//BaoCaoTT09PhuLuc5 TT09
export const BaoCaoTT09PhuLuc5 = createAsyncThunk(
  'report/BaoCaoTT09PhuLuc5',
  ({ agencyId, licensePlate = '', groupID = '', firstTime = '', lastTime = '', page = 1, pageSize = 30 }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/tt09/phuluc5/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//BaoCaoTT09PhuLuc8 TT09
export const BaoCaoTT09PhuLuc8 = createAsyncThunk(
  'report/BaoCaoTT09PhuLuc8',
  ({ agencyId, licensePlate = '', groupID = '', firstTime = '', lastTime = '', page = 1, pageSize = 30 }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/tt09/phuluc8/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//BaoCaoTT09PhuLuc14 TT09
export const BaoCaoTT09PhuLuc14 = createAsyncThunk(
  'report/BaoCaoTT09PhuLuc14',
  ({ agencyId, licensePlate = '', groupID = '', firstTime = '', lastTime = '', page = 1, pageSize = 30 }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/tt09/phuluc14/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//BaoCaoTT09PhuLuc16 TT09
export const BaoCaoTT09PhuLuc16 = createAsyncThunk(
  'report/BaoCaoTT09PhuLuc16',
  ({ agencyId, licensePlate = '', groupID = '', firstTime = '', lastTime = '', page = 1, pageSize = 30 }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/tt09/phuluc16/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//BaoCaoTT09PhuLuc17 TT09
export const BaoCaoTT09PhuLuc17 = createAsyncThunk(
  'report/BaoCaoTT09PhuLuc17',
  ({ agencyId, licensePlate = '', groupID = '', firstTime = '', lastTime = '', page = 1, pageSize = 30 }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/tt09/phuluc17/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);


//BaoCaoTT09PhuLuc09 TT09
export const BaoCaoTT09PhuLuc9 = createAsyncThunk(
  'report/BaoCaoTT09PhuLuc9',
  ({ agencyId, licensePlate = '', groupID = '', firstTime = '', lastTime = '', page = 1, pageSize = 30 }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/tt09/phuluc18/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//BaoCaoTT09PhuLuc19 TT09
export const BaoCaoTT09PhuLuc19 = createAsyncThunk(
  'report/BaoCaoTT09PhuLuc19',
  ({ agencyId, licensePlate = '', groupID = '', firstTime = '', lastTime = '', page = 1, pageSize = 30 }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/tt09/phuluc19/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//license_plate
export const licensePlate = createAsyncThunk(
  'report/licensePlate',
  ({ rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/vehicles/tracking/agency/${localStorage.getItem('agency-id')}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);


//group_id
// Nhận agencyId là ĐỐI SỐ, không đọc localStorage.
//
// Hai lỗi cũ nằm chồng nhau ở đây:
//
//  1. `({ rejectWithValue })` bóc từ đối số THỨ NHẤT (payload) chứ không phải thứ hai (thunkAPI).
//     Gọi groupID() không đối số là ném TypeError ngay, và kể cả có truyền object thì
//     rejectWithValue vẫn undefined.
//
//  2. URL đọc localStorage 'agency-id'. Khoá đó CÓ được ghi (authSlice khi Login), nhưng chỉ khi
//     user.agency tồn tại và chỉ trên đường Login — tải lại trang đi qua GetUserInfo thì không ai
//     ghi. Với admin và người dùng cuối nó là null, mà backend khai `agency_id:
//     Joi.number().required()` nên request hỏng ngay ở tầng kiểm tra tham số:
//     `"agency_id" must be a number`.
//
// Giá trị đúng là agency.id — service lọc `group_device.agency.id = :agencyId`. Trong FE đó là
// authSlice.agencyId (chỉ có với vai trò AGENCY, khớp đúng với quyền của route: agency + staff).
export const groupID = createAsyncThunk(
  'report/groupID',
  (agencyId, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/group_device/?agency_id=${agencyId}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);


export const reportTT09Slice = createSlice({
  name: 'report',
  initialState: {
    historyErrors: {},
    dataLicensePlate: null,
    dataGroupID: null,

    dataBaoCaoTT09PhuLuc5: null,
    dataBaoCaoTT09PhuLuc8: null,
    dataBaoCaoTT09PhuLuc9: null,
    dataBaoCaoTT09PhuLuc14: null,
    dataBaoCaoTT09PhuLuc16: null,
    dataBaoCaoTT09PhuLuc17: null,
    dataBaoCaoTT09PhuLuc19: null,
    isLoading: false

  },
  reducers: {
    resetDataSceen: state => {
      clearAllHistoryErrors(state);
      state.dataBaoCaoTT09PhuLuc5 = null;
      state.dataBaoCaoTT09PhuLuc8 = null;
      state.dataBaoCaoTT09PhuLuc9 = null;
      state.dataBaoCaoTT09PhuLuc14 = null;
      state.dataBaoCaoTT09PhuLuc16 = null;
      state.dataBaoCaoTT09PhuLuc17 = null;
      state.dataBaoCaoTT09PhuLuc19 = null;
    }
  },
  extraReducers: {

    [BaoCaoTT09PhuLuc5.pending]: state => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc5');
      state.isLoading = true;
    },
    [BaoCaoTT09PhuLuc5.fulfilled]: (state, action) => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc5');
      state.dataBaoCaoTT09PhuLuc5 = action.payload;
      state.isLoading = false;
    },
    [BaoCaoTT09PhuLuc5.rejected]: (state, action) => {
      setHistoryError(state, 'BaoCaoTT09PhuLuc5', action);
      state.dataBaoCaoTT09PhuLuc5 = null;
      state.isLoading = false;
    },
    /// BaoCaoTT09PhuLuc5

    [BaoCaoTT09PhuLuc8.pending]: state => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc8');
      state.isLoading = true;
    },
    [BaoCaoTT09PhuLuc8.fulfilled]: (state, action) => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc8');
      state.dataBaoCaoTT09PhuLuc8 = action.payload;
      state.isLoading = false;
    },
    [BaoCaoTT09PhuLuc8.rejected]: (state, action) => {
      setHistoryError(state, 'BaoCaoTT09PhuLuc8', action);
      state.dataBaoCaoTT09PhuLuc8 = null;
      state.isLoading = false;
    },
    /// BaoCaoTT09PhuLuc8

    [BaoCaoTT09PhuLuc14.pending]: state => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc14');
      state.isLoading = true;
    },
    [BaoCaoTT09PhuLuc14.fulfilled]: (state, action) => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc14');
      state.dataBaoCaoTT09PhuLuc14 = action.payload;
      state.isLoading = false;
    },
    [BaoCaoTT09PhuLuc14.rejected]: (state, action) => {
      setHistoryError(state, 'BaoCaoTT09PhuLuc14', action);
      state.dataBaoCaoTT09PhuLuc14 = null;
      state.isLoading = false;
    },
    /// BaoCaoTT09PhuLuc14

    [BaoCaoTT09PhuLuc16.pending]: state => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc16');
      state.isLoading = true;
    },
    [BaoCaoTT09PhuLuc16.fulfilled]: (state, action) => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc16');
      state.dataBaoCaoTT09PhuLuc16 = action.payload;
      state.isLoading = false;
    },
    [BaoCaoTT09PhuLuc16.rejected]: (state, action) => {
      setHistoryError(state, 'BaoCaoTT09PhuLuc16', action);
      state.dataBaoCaoTT09PhuLuc16 = null;
      state.isLoading = false;
    },
    /// BaoCaoTT09PhuLuc16

    [BaoCaoTT09PhuLuc17.pending]: state => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc17');
      state.isLoading = true;
    },
    [BaoCaoTT09PhuLuc17.fulfilled]: (state, action) => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc17');
      state.dataBaoCaoTT09PhuLuc17 = action.payload;
      state.isLoading = false;
    },
    [BaoCaoTT09PhuLuc17.rejected]: (state, action) => {
      setHistoryError(state, 'BaoCaoTT09PhuLuc17', action);
      state.dataBaoCaoTT09PhuLuc17 = null;
      state.isLoading = false;
    },

    [BaoCaoTT09PhuLuc9.pending]: state => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc9');
      state.isLoading = true;
    },
    [BaoCaoTT09PhuLuc9.fulfilled]: (state, action) => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc9');
      state.dataBaoCaoTT09PhuLuc9 = action.payload;
      state.isLoading = false;
    },
    [BaoCaoTT09PhuLuc9.rejected]: (state, action) => {
      setHistoryError(state, 'BaoCaoTT09PhuLuc9', action);
      state.dataBaoCaoTT09PhuLuc9 = null;
      state.isLoading = false;
    },
    /// BaoCaoTT09PhuLuc17

    [BaoCaoTT09PhuLuc19.pending]: state => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc19');
      state.isLoading = true;
    },
    [BaoCaoTT09PhuLuc19.fulfilled]: (state, action) => {
      clearHistoryError(state, 'BaoCaoTT09PhuLuc19');
      state.dataBaoCaoTT09PhuLuc19 = action.payload;
      state.isLoading = false;
    },
    [BaoCaoTT09PhuLuc19.rejected]: (state, action) => {
      setHistoryError(state, 'BaoCaoTT09PhuLuc19', action);
      state.dataBaoCaoTT09PhuLuc19 = null;
      state.isLoading = false;
    },
    /// BaoCaoTT09PhuLuc19

    ///licensePlate
    [licensePlate.pending]: state => {
    },

    [licensePlate.fulfilled]: (state, action) => {
      state.dataLicensePlate = action.payload.payload.latest_periodics;
    },

    [licensePlate.rejected]: (state, action) => {
      state.dataLicensePlate = null;
    },

    ///group_device
    [groupID.pending]: state => {
    },

    [groupID.fulfilled]: (state, action) => {
      state.dataGroupID = action.payload.payload.groupDevices;
    },

    [groupID.rejected]: (state, action) => {
      state.dataGroupID = null;
    },
  }
});

export const {
  resetDataSceen
} = reportTT09Slice.actions;

export default reportTT09Slice.reducer;
